import React from "react";
import styles from "./LiveStream.module.scss";
import { BsRecord2Fill } from "react-icons/bs";

const LiveStream = ({ channelId, videoId }) => {
  const src = videoId
    ? `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0`
    : `https://www.youtube.com/embed/live_stream?channel=${channelId}`;

  if (!videoId && !channelId) {
    return null;
  }

  return (
    <div className={styles.liveWrapper}>
      <div className={styles.liveBadge}>
        <BsRecord2Fill className={styles.dot} />
        LIVE
      </div>
      <div className={styles.videoContainer}>
        <iframe
          className={styles.iframe}
          src={src}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
          title="Live Stream"
        ></iframe>
      </div>
    </div>
  );
};

export default LiveStream;
